// Phone normalisation (spec 02 §5, spec 13 §2).
// This file exists twice, byte-identical (enforced by supabase/functions/_shared/phone.test.ts):
//   src/components/gavion/domain/phone.ts and supabase/functions/_shared/phone.ts.
// SQL twin: public.normalize_phone. Shared vectors: supabase/functions/_shared/fixtures/phone-vectors.json.

/** A NANP number as E.164 (+1XXXXXXXXXX), or null when it is not a valid NANP number. */
export function normalizePhone(raw: unknown): string | null {
  if (raw === null || raw === undefined) return null;
  const digits = String(raw).replace(/\D/g, "");
  if (/^1[2-9]\d{9}$/.test(digits)) return `+${digits}`;
  if (/^[2-9]\d{9}$/.test(digits)) return `+1${digits}`;
  return null;
}

/** "+14506551865" → "+1 450 655-1865" (spec 10 §6). Other values are returned unchanged. */
export function formatPhoneDisplay(e164: string | null | undefined): string {
  if (!e164) return "";
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `+1 ${m[1]} ${m[2]}-${m[3]}` : e164;
}
